
<template>
  <div id="userLayout"
       :class="['user-layout-wrapper', isMobile && 'mobile']">
    <div id="particles-js"
         class="container">
      <div class="user-layout-content">
        <div class="logo">
          <!-- logo去除 2023年4月3日15:31:50-->
          <LoginLogo v-show="showLogo === 'true'" />
        </div>
        <router-view />
        <div class="copyright">
          <!-- logo去除 2023年3月31日15:52:32 -->
          <a v-show="showLogo === 'true'"
             href="https://www.baidu.com/s?ie=utf-8&f=8&rsv_bp=1&rsv_idx=1&tn=baidu&wd=%E6%B9%96%E5%8D%97%E5%90%88%E6%B1%87%E7%A7%91%E6%8A%80&fenlei=256&rsv_pq=0xd8b93c3d0005c696&rsv_t=9487uHnUtRtjq44yD7fsy0Oc0epIYC5O9pkF%2Fnwg4VX7ybEaA2AXMBK4v27A&rqlang=en&rsv_dl=tb&rsv_enter=1&rsv_sug3=20&rsv_sug1=16&rsv_sug7=101&rsv_sug2=0&rsv_btype=i&prefixsug=%25E6%25B9%2596%25E5%258D%2597%25E5%2590%2588%25E6%25B1%2587%25E7%25A7%2591%25E6%258A%2580&rsp=5&inputT=6783&rsv_sug4=7473"
             target="_blank">湖南合汇科技有限公司</a>
          <a href="https://beian.miit.gov.cn/"
             target="_blank"
             style="color: #939393; transition: all 0.3s">湘ICP备2021013700号-1</a>
          <a target="_blank"
             href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=43100202000366"
             style="display:inline-block;text-decoration:none;height:20px;line-height:20px;">
            <img src="/iconImg/batb.png"
                 style="float:left;" />
            <p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;">湘公网安备
              43100202000366号</p>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { deviceMixin } from '@/store/device-mixin'
import SelectLang from '@/components/SelectLang'
import LoginLogo from '@/assets/myImg/logoBnanner.svg?inline'

import particlesJs from 'particles.js'
import particlesConfig from './particles.json'

export default {
  name: 'UserLayout',
  components: {
    SelectLang,
    LoginLogo
  },
  mixins: [deviceMixin],
  data () {
    return {
      showLogo: process.env.VUE_APP_LOGO
    }
  },
  mounted () {
    document.body.classList.add('userLayout')
    particlesJS('particles-js', particlesConfig)
  },
  beforeDestroy () {
    document.body.classList.remove('userLayout')
  }
}
</script>

<style lang="less" scoped>
#userLayout.user-layout-wrapper {
  height: 100%;

  .copyright {
    position: fixed;
    bottom: 20px;
    left: 0;
    right: 0;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  &.mobile {
    .container {
      width: 100%;
      height: 100%;
      background-color: #f0f1f2;

      .main {
        max-width: 368px;
        width: 98%;
      }
    }
  }

  #particles-js {
    width: 100%;
    height: 100%;
    position: relative;
    background-image: url(~@/assets/myImg/LoginBanner.png);
    background-position: 50% 50%;
    background-size: cover;
    background-repeat: no-repeat;
    margin-left: auto;
    margin-right: auto;
  }

  .container {
    .user-layout-lang {
      width: 100%;
      height: 40px;
      line-height: 44px;
      text-align: right;

      .select-lang-trigger {
        cursor: pointer;
        padding: 12px;
        margin-right: 24px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        font-size: 18px;
        vertical-align: middle;
      }
    }

    .user-layout-content {
      // width: 100%;
      // height: 100%;
      // position: relative;
      .logo {
        position: absolute;
        left: 3.2%;
        top: 3.9%;
        width: 14.7%;
        height: 6.5%;
        background-size: 100% 100%;
      }

      .top {
        text-align: center;

        .header {
          height: 44px;
          line-height: 44px;

          .badge {
            position: absolute;
            display: inline-block;
            line-height: 1;
            vertical-align: middle;
            margin-left: -12px;
            margin-top: -10px;
            opacity: 0.8;
          }

          .title {
            font-size: 33px;
            color: rgba(0, 0, 0, 0.85);
            font-family: Avenir, 'Helvetica Neue', Arial, Helvetica, sans-serif;
            font-weight: 600;
            position: relative;
            top: 2px;
          }
        }

        .desc {
          font-size: 14px;
          color: rgba(0, 0, 0, 0.45);
          margin-top: 12px;
          margin-bottom: 40px;
        }
      }

      .main {
        min-width: 260px;
        width: 368px;
        margin: 0 auto;
      }

      .leftContent {
        width: 70%;
        height: 100%;
        float: left;
        position: relative;
      }

      .rightContent {
        width: 28.8%;
        float: right;
        height: 100%;
        background-color: #fff;
        position: relative;

        .footer {
          position: absolute;
          width: 100%;
          bottom: 0;
          padding: 0 16px;
          margin: 80px 0 24px;
          text-align: center;

          .links {
            margin-bottom: 8px;
            font-size: 14px;

            a {
              color: rgba(0, 0, 0, 0.45);
              transition: all 0.3s;

              &:not(:last-child) {
                margin-right: 40px;
              }
            }
          }

          .copyright {
            font-family: MicrosoftYaHei;
            font-size: 12px;
            color: rgba(0, 0, 0, 0.2);
            letter-spacing: 0;
            text-align: center;
            font-weight: 400;
          }
        }
      }
    }

    a {
      text-decoration: none;
    }
  }
}
</style>
